import {
  Calendar03Icon,
  LeftToRightListBulletIcon,
} from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react-native';
import type { WithResponsive } from '@sunrise-ui/primitives';
import {
  Colors,
  useDynamicStyles,
  useMediaQueries,
} from '@sunrise-ui/primitives';
import { router, useGlobalSearchParams } from 'expo-router';
import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import { ToggleButton } from 'react-native-paper';

export enum ViewMode {
  LIST = 'list',
  CALENDAR = 'calendar',
}

export function ListCalendarViewToggle() {
  const styles = useDynamicStyles(createStyles);
  const { isMobile } = useMediaQueries();
  const { view } = useGlobalSearchParams<{ view?: ViewMode }>();

  const currentView =
    view === ViewMode.CALENDAR ? ViewMode.CALENDAR : ViewMode.LIST;

  const switchView = useCallback((newView: ViewMode) => {
    router.setParams({ view: newView });
  }, []);

  const handleValueChange = useCallback(
    (value: string) => {
      if (value) switchView(value as ViewMode);
    },
    [switchView],
  );

  const ListIcon = useCallback(
    ({ size, color }: { size: number; color: string }) => (
      <HugeiconsIcon
        icon={LeftToRightListBulletIcon}
        size={size}
        color={color}
      />
    ),
    [],
  );

  const CalendarIcon = useCallback(
    ({ size, color }: { size: number; color: string }) => (
      <HugeiconsIcon icon={Calendar03Icon} size={size} color={color} />
    ),
    [],
  );

  return (
    <View style={styles.toggleButtonRow}>
      <ToggleButton.Group onValueChange={handleValueChange} value={currentView}>
        <ToggleButton
          icon={ListIcon}
          size={isMobile ? 16 : 26}
          style={styles.toggleButton}
          value={ViewMode.LIST}
        />
        <ToggleButton
          icon={CalendarIcon}
          size={isMobile ? 16 : 26}
          style={styles.toggleButton}
          value={ViewMode.CALENDAR}
        />
      </ToggleButton.Group>
    </View>
  );
}

const createStyles = ({ isMobile }: WithResponsive) =>
  StyleSheet.create({
    toggleButtonRow: {
      flexDirection: 'row',
      backgroundColor: Colors.opacity05,
      borderRadius: isMobile ? 15 : 22,
    },
    toggleButton: {
      borderRadius: isMobile ? 15 : 22,
      width: isMobile ? 40 : 44,
      height: isMobile ? 40 : 44,
    },
  });
